import { useHeaderFilters } from '@/features/header-filters';
import { ActiveFiltersRow } from './active-filters-row';

interface ActiveFiltersBarProps {
  className?: string;
}

/**
 * Connects the shared header-filters context to the ActiveFiltersRow so a
 * single instance rendered in the layout surfaces the active page's applied
 * filters. Self-hides (renders null) when the current page has no active filters.
 */
export function ActiveFiltersBar({ className }: ActiveFiltersBarProps) {
  const { filterConfig } = useHeaderFilters();

  return (
    <ActiveFiltersRow
      filters={filterConfig?.activeFilters ?? []}
      onClearAll={filterConfig?.onClearAll}
      className={className}
    />
  );
}
